import React from "react";
import { ReactComponent as CheckIcon } from "assets/img/svg/fi_check.svg";

import { StudentPhotoOnIdCard } from "../../../studentDetails/studentPhoto";
import { isValidPhotoKey } from "../constant";
import CustomTooltip from "views/pages/manage/common/customTooltip/CustomTooltip";

const PhotoCellComponent = ({ params, nextButtonHandler }) => {
  console.log(params, "params");
  return (
    <div>
      {isValidPhotoKey(params?.photoKey) ? (
        <CheckIcon height={24} width={24} />
      ) : (
        <StudentPhotoOnIdCard
          psid={params?.psid}
          fetchApplications={() => nextButtonHandler()}
          photoKey={params?.photoKey}
        />
      )}
    </div>
  );
};

export default PhotoCellComponent;
